import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { isFetching } from 'utils/redux/fetching'
import { fetchStats } from 'redux/actions/actions'
import View from '../components/View'
import Loader from 'components/Loader'

class Home extends React.Component {

	componentWillMount() {
		const { dispatch } = this.props
		dispatch(fetchStats())
	}

	render () {
		if (this.props.isFetching) return <Loader />

		return <View {...this.props} />
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		dispatch
	}
}

const mapStateToProps = state => {

	const { stats } = state
	const { users, allocations } = stats

	if (isFetching([stats])) return { isFetching: true }

	return {
		users: users.allActiveCount,
		completedAllocations: allocations.allCompletedCount,
		skippedAllocations: allocations.allSkippedCount,
		realAllocations: allocations.allRealCount,
	}
}

Home.propTypes = {
	dispatch: PropTypes.func,
	isFetching: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)


// WEBPACK FOOTER //
// ./src/routes/Home/containers/Home.js